var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.type === "edit" ? "编辑" : "新增",
        visible: _vm.dialog,
        width: _vm.getIsMobile ? "100%" : "70%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialog = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "custom-form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": _vm.getIsMobile ? "top" : "right",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "公司名称", prop: "company" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入公司名称" },
                model: {
                  value: _vm.form.company,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "company", $$v)
                  },
                  expression: "form.company",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "公司类别", prop: "cid" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.cid,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "cid", $$v)
                    },
                    expression: "form.cid",
                  },
                },
                _vm._l(_vm.companyType, function (item) {
                  return _c(
                    "el-radio",
                    { key: item.cid, attrs: { label: item.cid } },
                    [_vm._v(_vm._s(item.classname))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "公司地址", prop: "address" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入公司地址" },
                model: {
                  value: _vm.form.address,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "address", $$v)
                  },
                  expression: "form.address",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "收货地址", prop: "raddress" } },
            [
              _c("Contacts", {
                ref: "contactFormRef",
                attrs: {
                  data: _vm.formData.child_lxr,
                  listrow: _vm.formData.listrow,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("Remarks", {
        ref: "remarkFormRef",
        attrs: { data: _vm.formData.child_content },
      }),
      _vm.type === "edit" ? _c("el-divider", [_vm._v("开票资料")]) : _vm._e(),
      _vm.type === "edit"
        ? _c("InvoiceInfo", {
            ref: "invoiceInfoFormRef",
            attrs: { data: _vm.formData.listrow },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleReset } }, [
            _vm._v("重 置"),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }